/**
 * Matomo-Loader — wird AUSSCHLIESSLICH nach erteilter Einwilligung aufgerufen.
 *
 * Konfiguration identisch zur Live-Site (/_extras/tracking/matomo.php):
 *   setDoNotTrack  – respektiert den DNT-Header des Browsers
 *   disableCookies – Matomo arbeitet komplett cookielos
 * Zusätzlich zur Live-Fassung: Matomo kürzt die IP serverseitig
 * (Administration → Datenschutz → "IP-Adressen anonymisieren"). Diese
 * Einstellung liegt in Matomo selbst und lässt sich hier nicht erzwingen —
 * sie muss dort gesetzt sein, sonst stimmt die Aussage im Banner nicht.
 */

let loaded = false

export function matomoLoaded() {
	return loaded
}

/**
 * @param {{url: string, siteId: string}} config
 */
export function loadMatomo({ url, siteId }) {
	if (loaded || !url || !siteId) return
	loaded = true

	const base = url.endsWith('/') ? url : url + '/'
	const paq = (window._paq = window._paq || [])

	paq.push(['setDoNotTrack', true])
	paq.push(['disableCookies'])
	paq.push(['setTrackerUrl', base + 'matomo.php'])
	paq.push(['setSiteId', String(siteId)])
	paq.push(['trackPageView'])
	paq.push(['enableLinkTracking'])

	const script = document.createElement('script')
	script.async = true
	script.src = base + 'matomo.js'
	document.head.appendChild(script)
}
